import { CLASSES } from '../_consts';

const { isActive } = CLASSES;

export default function accordion() {
  const $accordionItem = $('.js-accordion-item');
  const accordionContent = '.js-accordion-content'
  const $accessoriesSlider = $('.js-accessories-slider');


  $accordionItem.on('click', (e) => {
    const $target = $(e.currentTarget);
    const content = $target.next(accordionContent);
    const siblings = $target.siblings('.js-accordion-item').next(accordionContent);

    content.slideToggle();
    $target.toggleClass(isActive);

    siblings.hide();
    $target.siblings('.js-accordion-item').removeClass(isActive);

    if ($target.data('target') === 'accessories') {
      $accessoriesSlider.hide();
    } else {
      $accessoriesSlider.show();
    }

    if ($target.hasClass(isActive)) {
      setTimeout(() => {
        $("html, body").animate({ scrollTop: $target.offset().top }, 500);
      }, 500)
    }
  })
}
